import styled, { css } from "styled-components";
import { Input } from "antd";
import { theme } from "../../../config";
import { TextInputProps } from "./types";

const MediaQueryInputStyle = css`
  @media ${theme.breakpoints.mobileAndTablet} {
    height: 30px;
    font-size: 12.6px;
    line-height: 16px;
  }
`;

export const TextInputStyled = styled(Input).attrs(
  (props: TextInputProps) => ({
    ...props,
  }),
)`
  ${theme.defaultInputStyle}
  ${MediaQueryInputStyle}
  &.ant-input[disabled] {
    color: ${theme.colors.neutral.black3};
    background-color: ${theme.colors.neutral.black7};
    border: 1px solid #AAAAAA;

    &:hover {
      border-color: #AAAAAA;
    }
  }
  border: 1px solid
  ${({ $error }) => $error ? '#E3170A' : '#8e8c8c'};

  &:focus, &:hover {
    border: 1px solid  ${({ $error }) => $error ? '#E3170A' : theme.colors.secondary};
  }
  .ant-input-suffix .anticon-close-circle {
    & svg {
      width: 1.5em;
      height: 1.5em;
    }
  }
  &.ant-input-affix-wrapper:focus, 
  &.ant-input-affix-wrapper-focused {
    box-shadow: 0 0 0 2px #acdbda;
  }
`;

export const InputWrapper = styled.div`
  .ant-input-number-input {
    border: 0;
    height: 100%;
  }
  .ant-input-number-input:focus {
    border: 0;
  }
  .ant-input-number-input-wrap {
    height: 100%;
  }
  .ant-input-number {
    ${theme.defaultInputStyle}
    width: 100%;
    line-height: 21px;

  ${MediaQueryInputStyle}
  @media ${theme.breakpoints.mobileAndTablet} {
    padding-top: 0;
  }
  .ant-input-number:hover {
    border: 1px solid ${theme.colors.secondary};
  }
  &.ant-input-number-disabled {
    &:hover {
      border: 1px solid #8e8c8c;
    }
  }
  &.ant-input-number-disabled .ant-input-number-input {
    color: ${theme.colors.neutral.black3};
    background-color: ${theme.colors.neutral.black7};
  }
  &.ant-input-number-focused {
    box-shadow: 0 0 0 2px #acdbda;    
  }
`;

export const InputPassword = styled(Input.Password).attrs(
  (props: TextInputProps) => ({
    ...props,
  }),
)`
  ${theme.defaultInputStyle}
  border: 1px solid
  ${({ $error }) => $error ? '#E3170A' : '#8e8c8c'};
  &.ant-input-affix-wrapper > input.ant-input {
    font-size: 16px;
    line-height: 21px;

    @media ${theme.breakpoints.mobileAndTablet} {
      font-size: 12.6px;
      line-height: 16px;
    }
  }
  &.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):focus {
    border: 1px solid ${theme.colors.secondary};
  }
  &.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    border: 1px solid ${theme.colors.secondary};
  }
  ${MediaQueryInputStyle}
  &.ant-input[disabled] {
    color: ${theme.colors.neutral.black3};
    background-color: ${theme.colors.neutral.black7};
  }
  &.ant-input-affix-wrapper:focus, 
  &.ant-input-affix-wrapper-focused {
    box-shadow: 0 0 0 2px #acdbda;
  }
`;
